enum WorkflowTaskTypeEnum {
    CreateItem = 1,
    ApproveItem = 2,
    AddDocument = 3,
    ReviseDocument = 4,
    DoWork = 5,
    Wait = 6,
    ExecuteCode = 7,
    SetCustomFields = 8,
    UpdateDocument = 9,
    AddBusinessPartner = 10,
    AddPrice = 11,
    EditPrices = 12,
    EditItem = 13,
    EditItemRevisionDates = 14,
    SetProjectItemCustomFields = 15,
}
export default WorkflowTaskTypeEnum